/*global jQuery, GLightbox */
(function ($) {

  const lightbox = GLightbox({
    selector: '.js-lightbox',
    touchNavigation: true,
    loop: true,
    openEffect: 'fade',
    closeEffect: 'none'
  });

  $(window).on('load', function() {
    $('.js-lightbox').each(function() {
      if (!$(this).is('[tabindex="0"]')) {
        $(this).attr('tabindex', '0');
      }
      if (!$(this).is('[aria-label]')) {
        $(this).attr('aria-label', 'Lightbox öffnen');
      }
    });
  });

  $(document).on( 'click', '.js-lightbox-close', function() {
    lightbox.close();
  });

})(jQuery, window);
